import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import Splash from "../components/shared/Splash";
import {AuthenticationContext} from "../contexts/AuthenticationContext";
import {UserContext} from "../contexts/UserContext";
import {fetchActivityBadgeData} from "../slices/ActivitySlice";
import {fetchSharedRequirements} from "../slices/SharedSlice";
import {RootState} from "../slices/Store";
import {AppUser, AuthConfig, getAuthManager} from "../utils/auth";

export default function AuthenticationProvider(props: {
    children: JSX.Element | JSX.Element[];
}) {
    const dispatch = useDispatch();

    const [user, setUser] = useState<AppUser | null>(null);
    const [isAuthenticationRequired, setIsAuthenticationRequired] = useState(false);

    const sharedState = useSelector((state: RootState) => state.shared);

    const requireAuthenticatedUser = () => {
        setIsAuthenticationRequired(true);
    };

    const authenticationContextValue = {requireAuthenticatedUser};

    useEffect(() => {
        if (isAuthenticationRequired && user === null) {
            fetchRequirements();
        }
    }, [isAuthenticationRequired]);

    const fetchRequirements = async () => {
        const auth = getAuthManager();

        const user = await auth.initialize();

        if (user === null) {
            return;
        }

        await fetchSharedRequirements(sharedState, dispatch);
        await fetchActivityBadgeData(dispatch);

        setUser(new AppUser(user.user));
    };

    if (!user && isAuthenticationRequired) {
        return <Splash/>;
    }

    return (
        <AuthenticationContext.Provider value={authenticationContextValue}>
            {isAuthenticationRequired && (
                <UserContext.Provider value={user!}>
                    {props.children}
                </UserContext.Provider>
            )}

            {!isAuthenticationRequired && props.children}
        </AuthenticationContext.Provider>
    );
}
